import React from "react";
import { checkTextTranslation, checkTranslation, getObject, imageAddress, priceStandardView, setObject, translate } from '../../utils/useful'
import inputComponents from './inputComponents'
// import TextInput from './TextInput'
// import SidebarView from '../SidebarView'
// import FixedView from '../FixedView'
import ActionButton from "../partials/ActionButton";
// import StageActionButton from "../partials/StageActionButton";
import Collapsible from "react-collapsible";
// import SelectInput from "./SelectInput";
// import { Placeholder } from "react-bootstrap";


class RowTableInvoice extends React.Component {
    state = {
        width: window.innerWidth,
        tab: 1,
        actions: [

            {
                icon: "/assets/icons/applets/desk/square.filled.and.line.vertical.and.square.png",
                // nameShow: "Show Information",
                // nameHide: "Hide Information",
                name: '{{lang}}Information',
                onClick: 'information'
                // item: [
                //     { title: 'test' }
                // ]
            },

            {
                icon: "/assets/icons/applets/desk/plus.svg",
                name: "{{lang}}Clone",
                onClick: 'clone'
                // item: [
                //     { title: 'test' }
                // ]
            },
            {
                icon: "/assets/icons/applets/desk/trash.svg",
                name: "{{lang}}Remove",
                onClick: 'remove'
                //  item: [
                //     { title: 'test' }
                // ]
            },
        ],
        isOpen: false

    }
    componentDidMount() {
        this.init()
        window.addEventListener('resize', this.setFormWidth);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.setFormWidth)
    }
    formColBuilder(col) {
        let finalCol = 'col-12'

        if (100 < this.state.width && col) {
            finalCol = 'col-' + col
        }

        return finalCol
    }
    init = () => {
        this.makeInitValue(this.props.initData)
    }
    clone = () => {
        this.props.addNew()
    }
    information = () => {
        this.handleColapse()
    }
    remove = (index) => {
        this.props.removeRow(index)
    }
    handleColapse = () => {

        this.setState({ isOpen: !this.state.isOpen })
    }
    makeInitValue(rawData) {

        let data = rawData
        if (data == null) {
            data = {}
        }
        if (this.props.headers) {

            this.props.headers.forEach(header => {
                if (data[header.key] == null && header.information?.default != null) {
                    data[header.key] = header.information?.default
                }
            });
        }

        this.setState({ data: data, show: true }, () => {
            this.setFormWidth()
        })

    }

    setFormWidth = () => {
        if (this.form) {
            this.setState({ width: this.form.getBoundingClientRect().width })
        }
    }



    changeValue = (key, value, extra, fullObject, init) => {


        // console.log("changeValue", key, value, extra, fullObject)
        let sectionIndex = extra.sectionIndex
        let headers = this.props.headers
        let data = this.props.rawData ? { ...this.props.rawData } : {}

        let oldValue = value
        let updatePrice = false
        // console.log("changeValue", key, value,sectionIndex)

        if (value && typeof value == 'object') {
            oldValue = value?._id
        }


        if (key == 'variants') {

            sectionIndex = null
            if (!init) {

                updatePrice = true
            }
            setObject(data, 'variants', value)

        }

        if (key == 'additionals') {

            sectionIndex = null
            if (!init) {

                updatePrice = true
            }
            setObject(data, 'additionals', value)

        }


        if (sectionIndex == 0) {

            let oldData = data ? data[headers[0]?.key] : null

            if (value && typeof value == 'object') {
                oldValue = value?._id
            }

            if (oldData != value) {

                updatePrice = true

                setObject(data, headers[0].key, oldValue)
                setObject(data, 'unit', fullObject?.unit)
                setObject(data, 'image', fullObject?.image)
            }

            this.props.setFullProduct(fullObject)
        }

        if (this.props.header?.information?.updatePrice == false) {
            updatePrice = false
        }


        if (updatePrice) {

            let price = (fullObject?.price ? fullObject?.price : 0)
            let basePrice = (fullObject?.price ? fullObject?.price : 0)
            let finalPrice = (fullObject?.price ? fullObject?.price : 0)

            if (finalPrice && typeof finalPrice == 'object') {
                basePrice = price.base
                finalPrice = price.final
            }

            if (fullObject?.priceType == 'subscription') {
                let subscriptionPrice = fullObject?.subscriptionPrice
                if (Array.isArray(subscriptionPrice)) {
                    finalPrice = subscriptionPrice[0]?.price ?? 0

                    if (subscriptionPrice[0]?.duration == 'year') {
                        finalPrice = finalPrice * 12
                    }
                }
            } else {

                if (data.variants && fullObject?.inventory?.variants) {
                    let variantPrice = this.checkVariantsPrices(fullObject, data.variants)
                    if (variantPrice != null) {
                        price = variantPrice
                        finalPrice = price.final
                    }
                }

            }

            let additionalsPrice
            if (data.additionals) {
                additionalsPrice = this.calculateAdditionals(fullObject, data.additionals)
                finalPrice = finalPrice + (additionalsPrice ?? 0)
                // console.log("additionalsPrice", additionalsPrice)
            }

            setObject(data, 'amounts.additionals', additionalsPrice)


            // console.log("data", data)
            // console.log("fullObject", fullObject)

            if (isNaN(finalPrice)) {
                finalPrice = 0
            }


            let quantity = getObject(data, headers[1].key)


            if (!quantity && finalPrice) {
                quantity = 1
                setObject(data, headers[1].key, 1)
            }

            setObject(data, headers[2].key, finalPrice ?? 0)

        }



        if (sectionIndex == 2) {

            setObject(data, headers[2].key, value)

            let rate = getObject(data, headers[2].key)
            let quantity = getObject(data, headers[1].key)

            if (!quantity) {
                setObject(data, headers[1].key, 1, false)
                quantity = 1
            }

            let amount = Number(rate ?? 0) * Number(quantity ?? 0)

            setObject(data, headers[3].key, Number(amount.toFixed(2)))
        }


        if (sectionIndex == 1) {

            // if (!value || value == '') {
            //     value = 0
            // }
            setObject(data, headers[1].key, value)

        }

        let quantity = getObject(data, headers[1].key)
        let rate = getObject(data, headers[2].key)
        let amount = Number(rate ?? 0) * Number(quantity ?? 0)

        setObject(data, headers[3].key, Number(amount.toFixed(2)))
        this.props.changeValue(this.props.header?.key, data, extra, fullObject, init)


    }


    calculateAdditionals = (product, activeAdditionals) => {

        // TO DO: consider remoced or changed additionals
        let additionalsPrice = 0
        if (typeof activeAdditionals == 'object') {

            for (const [key, value] of Object.entries(activeAdditionals)) {

                product.additionals.forEach(additional => {

                    if (additional.title?.toLowerCase() == key.toLowerCase()) {


                        if (!additional.type || additional.type == 'singleSelect' || additional.type == 'multiSelect') {

                            if (typeof value == 'object') {

                                for (const [optionKey, optionValue] of Object.entries(value)) {

                                    if (Array.isArray(additional.options)) {

                                        for (let o = 0; o < additional.options.length; o++) {
                                            const option = additional.options[o];

                                            if (option.label && optionKey?.toLowerCase() == option.label.toLowerCase()) {

                                                if (option.priceDifference && this.getPriceByKey(option.priceDifference)) {
                                                    additionalsPrice = additionalsPrice + this.getPriceByKey(option.priceDifference)
                                                }
                                            }

                                        }

                                    }

                                }
                            }
                        }

                    }
                });

            }
        }

        return additionalsPrice

    }



    getPriceByKey(price, key) {
        let final = price
        if (!key) {
            key = 'final'
        }
        if (typeof price == 'object') {
            if (price.final != null) {
                final = price[key]
            } else {
                final = price.base
            }
        }

        return Number(final)
    }



    checkVariantsPrices = (product, activeVariants) => {

        // console.log("checkVariantsPrices")
        if (Array.isArray(product?.variants) && activeVariants) {
            // let activeVariants = activeVariants
            // let variants = product?.variants

            if (Array.isArray(product?.inventory?.variants)) {
                let final = {}
                let variantInventory = product?.inventory?.variants
                let price
                let variantsCount = product?.variants.length

                variantInventory.forEach(element => {

                    let allIsSame = true

                    for (const [key, value] of Object.entries(element.attributes)) {

                        // console.log(activeVariants)
                        // console.log(key, value, activeVariants[key])
                        if (activeVariants[key] != value) {
                            allIsSame = false
                        }

                    }

                    if (allIsSame) {
                        price = element.price
                        // console.log("FOUND", element)
                    }

                })

                // console.log(price)

                return price
                // this.setState({ variantsPriceDifferences: final })

            }
        }
    }







    render() {

        const { headers, rawData, index, changeValue, sidebarView } = this.props

        return (
            <div className="w-100">
                <div className="flexc w-100">
                    <div>
                        <ActionButton>
                            <div className='actionlist' >

                                {this.state.actions.map((prop, index) => {
                                    return (
                                        <>


                                            <div onClick={() => { this[prop.onClick](index) }} className='action-option py-2' style={{ cursor: 'pointer' }}>

                                                <img src={prop.icon} alt="" />

                                                {prop.name == 'Information' ? (
                                                    <p className="p-0">
                                                        {this.state.isOpen ? translate("Hide information") : translate('Show information')}
                                                    </p>
                                                ) : (
                                                    <p className="p-0">

                                                        {checkTranslation(prop.name)}
                                                    </p>
                                                )}
                                            </div>

                                        </>
                                    )
                                })}

                            </div>
                        </ActionButton>
                    </div>

                    <div className="d-flex w-100">

                        {headers && headers.map((header, index) => {
                            let Component = inputComponents[header.type]
                            let data = getObject(rawData, header.key)
                            let files
                            if (rawData && rawData['**files']) {
                                files = getObject(rawData['**files'], header.key)
                            }

                            if (data == null && header.information?.default != null) {
                                data = header.information?.default
                            }

                            if (Component) {

                                let extra = { ...this.props.extra }
                                extra.sectionIndex = index

                                return (
                                    <div key={index} className={" mb-0 flex-1 " + (index != headers.length - 1 ? 'invoice-table-border ' : '') + this.formColBuilder(header.col)} style={{ padding: 0, }}>

                                        <div className={"row m-0 pb-2 pt-1 px-2 "} >

                                            <div className="col-12 p-0 text-small" >
                                                <div className={"flexc " + (header.information.inputClass ?? (this.props.inputClass ? this.props.inputClass : ''))}>
                                                    {header.information?.icon && (
                                                        <img className="mrd-3" src={header.information?.icon} height="25px" alt="icon" />
                                                    )}
                                                    <Component header={header} data={data} fullData={rawData} files={files} changeFiles={this.changeFiles} changeValue={this.changeValue} variables={this.props.variables} optionsList={this.props.optionsList} extra={extra} setFetchedData={this.props.setFetchedData} fetchedData={this.props.fetchedData?.[header?.key]} />

                                                    {header.key == 'item' && getObject(rawData, 'image') && (
                                                        <div>
                                                            <img src={imageAddress(getObject(rawData, 'image'), 'product', 'thumb')} style={{ height: 20, width: 20, borderRadius: 20 }} />
                                                        </div>
                                                    )}

                                                </div>

                                            </div>

                                            <div className="text-start">
                                                {header.key == 'item' && (
                                                    <button className="text-smaller mt-1 p-0 px-1 text-start" style={{ color: '#9ab' }}>{translate("Add description?")}</button>
                                                )}

                                                {header.key == 'rate' && (
                                                    <button onClick={() => sidebarView.openSidebar()} className="text-smallest mt-1 p-0 text-start" style={{ color: '#007aff' }}>{translate("Transactions")}</button>
                                                )}

                                                {header.key == 'quantity' && getObject(rawData, 'unit') && (
                                                    <p className="text-smaller mt-1 p-0" >{translate("unit")}: {checkTranslation(getObject(rawData, 'unit'))}</p>
                                                )}

                                            </div>



                                            {this.props.errors && this.props.errors[header.key] && (
                                                <div className="col-12 mt-1 mld-2 text-start">
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.props.errors[header.key])}</small>
                                                </div>
                                            )}

                                            {this.state.errors && this.state.errors[header.key] && (
                                                <div className="col-12 mt-1 mld-2 text-start">
                                                    <small style={{ color: '#ee5050' }}>{checkTextTranslation(this.state.errors[header.key])}</small>
                                                </div>
                                            )}

                                        </div>
                                    </div>
                                )
                            }
                        })}

                    </div>


                </div>
                <div>
                    <Collapsible open={this.state.isOpen}>
                        <div className="py-2 px-1 d-flex" style={{ background: '#fafafa', }}>
                            <div className="flexc mrd-5 prd-5">
                                <img className="mrd-2" src="/assets/icons/notebook.png" width={15} alt="" />
                                <p style={{ fontSize: 13, color: '#404040' }}>{translate("Select account")}</p>
                            </div>
                            <div className="flexc mrd-5 prd-5">
                                <img className="mrd-2" src="/assets/icons/bag.png" width={15} alt="" />
                                <p style={{ fontSize: 13, color: '#404040' }}>{translate("Select a project")}</p>
                            </div>
                            <div className="flexc ">
                                <img className='mrd-2' src="/assets/icons/price-tag.png" width={12} alt="" />
                                <p style={{ fontSize: 13, color: '#404040' }}>{translate("Reporting tags")}</p>
                            </div>
                        </div>
                    </Collapsible>
                </div>
            </div>
        )
    }

}



export default RowTableInvoice;


